import React from 'react'
import Skeleton from 'react-loading-skeleton'

function SkeletonStepIcon(){
    return <div className="text-center font-weight-bold">
        <button 
            className={`btn btn-lg btn-default btn-floating btn-block mx-auto`} 
            style={{
                padding: "14px 8px",
                opacity: "1"
            }} 
            disabled={true}
        >
            <Skeleton count={3} />
        </button>
        <Skeleton count={1} />
    </div>
}

export default SkeletonStepIcon